var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLocationImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.3285 28.9707C39.1985 30.0463 40.3351 31.4151 40.3351 32.9918C40.3351 36.3651 34.8595 39.1029 28.1128 39.1029C21.3662 39.1029 15.8906 36.3651 15.8906 32.9918C15.8906 31.4518 17.0273 30.0463 18.9095 28.9707",
    stroke: "#656363",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7891 21.9954C20.7891 20.0505 21.5616 18.1853 22.9369 16.81C24.3122 15.4347 26.1775 14.6621 28.1224 14.6621C30.0673 14.6621 31.9326 15.4347 33.3079 16.81C34.6832 18.1853 35.4557 20.0505 35.4557 21.9954C35.4557 29.3899 28.1224 32.9954 28.1224 32.9954C28.1224 32.9954 20.7891 29.3899 20.7891 21.9954Z",
    stroke: "#656363",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1124 23.8322C29.4624 23.8322 30.5569 22.7378 30.5569 21.3878C30.5569 20.0378 29.4624 18.9434 28.1124 18.9434C26.7624 18.9434 25.668 20.0378 25.668 21.3878C25.668 22.7378 26.7624 23.8322 28.1124 23.8322Z",
    fill: "#44475C"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationImg);
export default __webpack_public_path__ + "static/media/LocationImg.b2aa89098e6253f88221053fad0a6a48.svg";
export { ForwardRef as ReactComponent };